import { render, staticRenderFns } from "./fixedRightSwipe.vue?vue&type=template&id=50932bf8&scoped=true"
import script from "./fixedRightSwipe.vue?vue&type=script&lang=js"
export * from "./fixedRightSwipe.vue?vue&type=script&lang=js"
import style0 from "./fixedRightSwipe.vue?vue&type=style&index=0&id=50932bf8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50932bf8",
  null
  
)

export default component.exports